import React, { useRef, useState } from 'react';
import Modal from 'react-bootstrap/Modal';

import useTableScroll from "../components/useTableScroll.js";
 
import { Mensaje } from '../components/mensajes';
import axios from "axios";
import moment from 'moment';
import {Dimmer} from "../components/spinner";
import { formatMoneda } from '../util/varios.js';


const CatalogoCompromisos = props => {

    let op = require('../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');
    const idefiscal = JSON.parse(localStorage.getItem('idefiscal'));

    const btnCancela = useRef();
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [activate, setActivate] = useState(false);
    const [records, setRecords] = useState([]);
    const [values, setValues] = useState({});
    const [activo, setActivo] = useState(true);
    const [itemSelect, setItemSelect] = useState(-1);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })

    const headCells = [
        { label: 'N° COMPROMISO', textAlign: 'center' },
        { label: 'CONCEPTO', textAlign: 'center' },
        { label: 'MONTO', textAlign: 'center' },
    ]

    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTableScroll(records, headCells, filterFn);

    const handleSearch = e => {
        let target = e.target;

        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items;
                } else {
                    return items.filter(x => {
                        if (x.idcompromiso.includes(target.value)
                            || x.concepto.toLowerCase().includes(target.value.toLowerCase())
                            || formatMoneda(x.razonsocial.toString().replace(',', '').replace('.', ','), ',', '.', 2).includes(target.value)) {
                            return x;
                        }
                    });
                }
            }
        })

    }

    const seleccionarCompromisos = () => {

        let tipo = props.tipo;
        let ubi = props.ubi;
        let estatus = props.sta;
        let reversa = props. rever;

        let endpoint = `${op.conexion}/api/presupuesto/registroscompromisoscat?idefiscal=${idefiscal}&tipo=${tipo}&ubi=${ubi}&estatus=${estatus}&reversa=${reversa}`;
        console.log(endpoint)
        setActivate(true);

        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then(function (response) {

            if (response.status === 200) {

                setActivate(false);
                var data = []
                for (let i = 0; i < response.data.length; i++) {
                    data.push({
                        idcompromiso: response.data[i].idcompromiso,
                        tipo: response.data[i].tipo,
                        referencia: response.data[i].referencia,
                        fecha: response.data[i].fecha,
                        idproveedor: response.data[i].idproveedor,
                        idcoordinacion: response.data[i].idcoordinacion,
                        idefiscal: response.data[i].idefiscal,
                        concepto: response.data[i].concepto,
                        reversado: response.data[i].reversado,
                        montocompromiso: response.data[i].montocompromiso,
                        ubicacion: response.data[i].ubicacion,
                        status: response.data[i].status,
                        montoiva: response.data[i].montoiva,
                        fechafactura: response.data[i].fechafactura,
                        nrofactura: response.data[i].nrofactura,
                        nrocontrol: response.data[i].nrocontrol,
                        idusuario_crea: response.data[i].idusuario_crea,
                        fecha_crea: response.data[i].fecha_crea,
                        fecha_reverso: response.data[i].fecha_reverso,
                        idusuario_reversa: response.data[i].idusuario_reversa,
                        idtipopago: response.data[i].idtipopago,
                        iddatpresu: response.data[i].iddatpresu,
                        observacion: response.data[i].observacion
                    })
                }
                setRecords(data)
            }


        }).catch(function (error) {

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });

        }).finally(function () {
            setActivate(false);
        });

    }

    const blanquear = () => {
        setActivate(false);
        setRecords([]);
        setFilterFn({ fn: items => { return items; } });
        setItemSelect("");
        setActivo(true);
    }


    const cancelar = () => {

        blanquear();
        props.onHideCancelar();
    }

    const selectOrden = () => {

        var idcompromiso = values[0].idcompromiso;
        var tipo = values[0].tipo;
        var referencia = values[0].referencia;
        var fecha = values[0].fecha;
        var idproveedor = values[0].idproveedor;
        var idcoordinacion = values[0].idcoordinacion;
        var idefiscal = values[0].idefiscal;
        var concepto = values[0].concepto;
        var reversado = values[0].reversado;
        var montocompromiso = values[0].montocompromiso;
        var ubicacion = values[0].ubicacion;
        var status = values[0].status;
        var montoiva = values[0].montoiva;
        var fechafactura = values[0].fechafactura;
        var nrofactura = values[0].nrofactura;
        var nrocontrol = values[0].nrocontrol;
        var idusuario_crea = values[0].idusuario_crea;
        var fecha_crea = values[0].fecha_crea;
        var fecha_reverso = values[0].fecha_reverso;
        var idusuario_reversa = values[0].idusuario_reversa;
        var idtipopago = values[0].idtipopago;
        var iddatpresu = values[0].iddatpresu;
        var observacion = values[0].observacion;

        blanquear();
        props.onHideAceptarCompromiso(idcompromiso, tipo, referencia, fecha, idproveedor, idcoordinacion, idefiscal, concepto, reversado, montocompromiso,
            ubicacion, status, montoiva, fechafactura, nrofactura, nrocontrol, idusuario_crea, fecha_crea, fecha_reverso, idusuario_reversa,
             idtipopago, iddatpresu, observacion);
        props.onHideCancelar();
    };

    const seleccionarFila = (index) => (e) => {
        e.preventDefault();
        setItemSelect(index);
        setActivo(false);

        var idcompromiso = recordsAfterPagingAndSorting()[index].idcompromiso;
        var tipo = recordsAfterPagingAndSorting()[index].tipo;
        var referencia = recordsAfterPagingAndSorting()[index].referencia;
        var fecha = recordsAfterPagingAndSorting()[index].fecha;
        var idproveedor = recordsAfterPagingAndSorting()[index].idproveedor;
        var idcoordinacion = recordsAfterPagingAndSorting()[index].idcoordinacion;
        var idefiscal = recordsAfterPagingAndSorting()[index].idefiscal;
        var concepto = recordsAfterPagingAndSorting()[index].concepto;
        var reversado = recordsAfterPagingAndSorting()[index].reversado;
        var montocompromiso = recordsAfterPagingAndSorting()[index].montocompromiso;
        var ubicacion = recordsAfterPagingAndSorting()[index].ubicacion;
        var status = recordsAfterPagingAndSorting()[index].status;
        var montoiva = recordsAfterPagingAndSorting()[index].montoiva;
        var fechafactura = recordsAfterPagingAndSorting()[index].fechafactura;
        var nrofactura = recordsAfterPagingAndSorting()[index].nrofactura;
        var nrocontrol = recordsAfterPagingAndSorting()[index].nrocontrol;
        var idusuario_crea = recordsAfterPagingAndSorting()[index].idusuario_crea;
        var fecha_crea = recordsAfterPagingAndSorting()[index].fecha_crea;
        var fecha_reverso = recordsAfterPagingAndSorting()[index].fecha_reverso;
        var idusuario_reversa = recordsAfterPagingAndSorting()[index].idusuario_reversa;
        var idtipopago = recordsAfterPagingAndSorting()[index].idtipopago;
        var iddatpresu = recordsAfterPagingAndSorting()[index].iddatpresu;
        var observacion = recordsAfterPagingAndSorting()[index].observacion;

        var datos = [];
        datos.push({
            idcompromiso,
            tipo,
            referencia,
            fecha,
            idproveedor,
            idcoordinacion,
            idefiscal,
            concepto,
            reversado,
            montocompromiso,
            ubicacion,
            status,
            montoiva,
            fechafactura,
            nrofactura,
            nrocontrol,
            idusuario_crea,
            fecha_crea,
            fecha_reverso,
            idusuario_reversa,
            idtipopago,
            iddatpresu,
            observacion
        });
        setValues(datos);

    };

    return (
        <Modal
            {...props}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            size="lg"
            backdrop="static"
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            keyboard={false}
            onShow={() => {
                seleccionarCompromisos()
            }}
        >
            <Modal.Header className='azulGradiant header-modal'>
                <div className="fw-bold text-light"><h3>Seleccionar Compromiso</h3></div>
                <button ref={btnCancela} className="bg-transparent" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>
            </Modal.Header>
            <Modal.Body>
                <Mensaje mensaje={mensaje}
                    onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />
              <Dimmer active={activate} inverted>
       
      </Dimmer>
                <div className="col-md-12 m-0">

<div className="input-group input-group-sm mb-3 m-0 col-md-5">
    <input type='text'
        onChange={handleSearch} className="form-control rounded-pill search-input" />
</div>
</div>
                <div className="col-md-12" style={{ margin: "auto" }} >
                    <TblContainer >
                        <TblHead />

                        <tbody>
                            {
                                records && recordsAfterPagingAndSorting().map((item, index) => (
                                    <tr key={index} style={{ padding: "0", cursor: 'pointer', background: itemSelect === index ? "lightskyblue" : "white" }} onClick={seleccionarFila(index)} >
                                        <td className='py-2 text-center' style={{ width: '60px' }}>{item.idcompromiso}</td>
                                        <td className='py-2 text-center' style={{ width: '250px' }}>{item.concepto}</td>
                                        <td className='py-2 text-right' style={{ width: '80px' }}>{formatMoneda(item.montocompromiso.toString().replace(',', '').replace('.', ','), ',', '.', 2)}</td>
                                    </tr>

                                ))
                            }
                        </tbody>

                    </TblContainer>
                    <TblPagination />

                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-sm btn-success rounded-pill" disabled={activo} style={{ margin: "5px" }} onClick={selectOrden}><i className="fas fa-check-circle"> Aceptar</i> </button>
                <button ref={btnCancela} onClick={cancelar} className="btn btn-sm btn-danger rounded-pill"><i className="fas fa-window-close"> Cancelar</i></button>
            </Modal.Footer>
        </Modal>
    );
}

export default CatalogoCompromisos;